import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Clock, ArrowLeft, Bell } from 'lucide-react';

export default function ComingSoonPage() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[60vh]" data-testid="coming-soon-page">
      <Card className="max-w-md w-full border-dashed border-2 border-gray-300">
        <CardContent className="p-10 text-center">
          <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 flex items-center justify-center mb-4">
            <Clock className="h-8 w-8 text-amber-600" />
          </div>
          <Badge className="bg-amber-100 text-amber-700 mb-3">Coming Soon</Badge>
          <h2 className="text-xl font-bold text-gray-800 mb-2">This Module is Under Development</h2>
          <p className="text-sm text-gray-500 mb-6">
            We're building this module right now. Want to be notified when it launches? Visit Module Management to submit your interest.
          </p>
          <div className="flex gap-2 justify-center">
            <Button variant="outline" onClick={() => navigate(-1)} className="gap-1.5">
              <ArrowLeft className="h-3.5 w-3.5" />Back
            </Button>
            <Button onClick={() => navigate('/settings/module-manager?tab=ideas')} className="bg-amber-600 hover:bg-amber-700 gap-1.5">
              <Bell className="h-3.5 w-3.5" />Request This Module
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
